import React from 'react';
import ReactDOM from 'react-dom';
import "antd/dist/antd.css"
import PageRouter from "./PageRouter";
import './index.css';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';
import {ConfigProvider} from "antd";


ReactDOM.render(//ReactDOM  第三方模块
    <ConfigProvider locale={locale}>
        <PageRouter/>
    </ConfigProvider>,
    document.getElementById('root')
);